<template>
    <div class="row mt-4">
        <div class="col-md-6 text-left">
            <h5 class="mt-1 mb-2 uk-text-bold">
                <i class="fas fa-chart-bar mr-2"></i> Bodyguard price list
            </h5>
        </div>
 
        <div class="col-md-12 pt-3">
            <form @submit.prevent="updatePrice" ref="updatePriceForm">
                <div class="table-responsive">
                    <table class="table data-table table-round table-hover">
                        <thead>
                            <tr>
                                <th width="12%" class="pl-4 pr-4">Staff Type</th>
                                <th width="12%" class="pl-4 pr-4">Period</th>
                                <th width="12%" class="pl-4 pr-4">Range Value</th>
                                <th width="16%" class="pl-4 pr-4">Hour Per Day</th>
                                <th width="16%" class="pl-4 pr-4">Price Per Staff</th>
                                <th width="16%" class="pl-4 pr-4">Armed</th>
                                <th width="16%" class="pl-4 pr-4">Expat</th>
                                <th class="blankhead" width="auto"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(price, priceIndex) in priceLists" :key="priceIndex">
                                <td class="bg-white pl-4 pr-4 pt-3">
                                    <div class="form-group select-dropdown mb-2 mt-0">
                                        <select name="staff_type" v-model="priceLists[priceIndex].staff_type" class="form-control uk-form-small pt-0" required>
                                            <option :value="'bodyguard'">Bodyguard</option>
                                        </select>
                                    </div>
                                </td>
                                <td class="bg-lightblue pl-4 pr-4 pt-3">
                                    <div class="form-group select-dropdown mb-2 mt-0">
                                        <select name="range_period" v-model="priceLists[priceIndex].range_period" class="form-control uk-form-small pt-0" required>
                                            <option :value="'half-day'">Half Day</option>
                                            <option :value="'day'">Day</option>
                                            <option :value="'week'">Week</option>
                                            <option :value="'month'">Month</option>
                                        </select>
                                    </div>
                                </td>
                                <td class="bg-white pl-4 pr-4 pl-4 pr-4 pt-3 pb-2">
                                    <div class="form-group mb-2 mt-1">
                                    <input type="text" name="range_value" v-model="priceLists[priceIndex].range_value" class="form-control uk-form-small pt-0" required />
                                    </div>
                                </td>
                                <td class="bg-lightblue pl-4 pr-4 pl-4 pr-4 pt-3 pb-2">
                                    <div class="form-group mb-2 mt-1">
                                    <input type="text" name="hour_per_day" v-model="priceLists[priceIndex].hour_per_day" class="form-control uk-form-small pt-0" required />
                                    </div>
                                </td>
                                <td class="bg-white pl-4 pr-4 pl-4 pr-4 pt-3 pb-2">
                                    <div class="form-group mb-2 mt-1">
                                        <span class="uk-form-icon"> {{ (price.formatted_price_per_staff? price.formatted_price_per_staff : '฿' ) | priceSymbol}} </span>
                                        <input type="text" name="price_per_staff" v-model="priceLists[priceIndex].price_per_staff" class="uk-input uk-form-small pt-0" required />
                                    </div>
                                </td>
                                <td class="bg-lightblue pl-4 pr-4 pt-3 pb-2">
                                    <div class="form-group mb-2 mt-1">
                                        <span class="uk-form-icon"> {{ (price.formatted_armed? price.formatted_armed : '฿') | priceSymbol}} </span>
                                        <input type="text" name="armed" v-model="priceLists[priceIndex].armed" class="uk-input uk-form-small pt-0" required />
                                    </div>
                                </td>
                                <td class="bg-white pl-4 pr-4 pt-3 pb-2">
                                    <div class="form-group mb-2 mt-1">
                                        <span class="uk-form-icon"> {{ (price.formatted_expat? price.formatted_expat : '฿') | priceSymbol}} </span>
                                        <input type="text" name="expat" v-model="priceLists[priceIndex].expat" class="uk-input uk-form-small pt-0" required />
                                    </div>
                                </td>
                                <td class="bg-lightblue text-right">
                                    <a href="#" @click="copyBodyguardPrice(priceIndex)" class="edit-btn" uk-toggle><i class="far fa-copy"></i></a>
                                    <a href="#" class="del-btn"><i class="fal fa-trash-alt"></i></a>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="9">
                                    <a @click="addBodyguardPrice" class="save-btn sendmail-btn border-0 mt-2 mb-2 text-center" >
                                        <i class="fas fa-plus mr-2" style="font-size: 15px; display: block"></i> Add
                                    </a>
                                    <button v-if="priceLists.length > 0" type="submit" id="client" class="save-btn border-0 ml-2 mr-2 float-right">
                                        <i class="fas fa-save mr-2" aria-hidden="true"></i> Save
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </form>
        </div>
    </div>
</template>


<script>

export default {
    props: {
        companyDetail: Object
    },
    mounted() {
        this.bodyguardPrices()
    },
    data() {
        return {
            priceLists: [],
            formData: []
        }
    },
    methods: {
        bodyguardPrices() {
            const api = 'admin/agencies/' + this.$route.params.id + '/prices'
            axios
                .get(api, {
                    params: {
                        page:1,
                        limit:30
                    }
                })
                .then((response) => {
                    this.priceLists = response.data.data
                })
                .catch((error) => {
                    console.error('There was an error!', error.message)
                })
                
        },
        addBodyguardPrice() {
            console.log('sfd')
            this.priceLists.push({
                range_period: 'month',
                staff_type: 'bodyguard'
            })
        },
        copyBodyguardPrice(index) {
            this.priceLists.push(this.priceLists[index])
        },
        updatePrice() {
            console.log(this.priceLists)
            // this.loading()
            const api = 'admin/agencies/' + this.$route.params.id + '/prices'
            axios
                .post(api, {prices: this.getFormData()})
                .then((response) => {
                    console.log(response.data)
                    if(response.data.success) {
                        this.success()
                    }else{
                        this.requiredfileds = response.data
                    }
                })
                .catch((error) => {
                    console.error('There was an error!', error.message)
                })
        },
        getFormData() {
            // let form = this.$refs.updatePriceForm;
            // let formData = new FormData(form);

            return this.priceLists
        },
        success() {
            var notyf = new Notyf();
                notyf.confirm('Successfully Updated!');
        }
    },

}
</script>